"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceTable = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _DenseTable = _interopRequireDefault(require("./DenseTable"));
var _constants = require("../../../utils/constants");
var _selectors = require("../../../redux/selectors");
var _DeviceRows = require("./DeviceRows");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const DeviceTable = exports.DeviceTable = /*#__PURE__*/(0, _react.memo)(() => {
  const [filteredDeviceList, setFilteredDeviceList] = (0, _react.useState)([]);
  const [heaterList, setHeaterList] = (0, _react.useState)([]);
  const [drinkWaterList, setDrinkWaterListList] = (0, _react.useState)([]);
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const filteredIdList = (0, _reactRedux.useSelector)(_selectors.selectFilteredIdList, _paulCorePackage.functions.areEqual);
  const deviceList = (0, _reactRedux.useSelector)(_selectors.selectDevicesById, _paulCorePackage.functions.areEqual);
  (0, _react.useEffect)(() => {
    setFilteredDeviceList(filteredIdList.map(id => deviceList[id]));
  }, [deviceList, filteredIdList]);
  (0, _react.useEffect)(() => {
    const getDeviceListByGroup = function getDeviceListByGroup() {
      let groupType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return groupType.reduce((accTypes, equipmentType) => [...accTypes, ...filteredDeviceList.filter(device => (device === null || device === void 0 ? void 0 : device.equipmentType) === equipmentType)], []);
    };
    setHeaterList(getDeviceListByGroup(_constants.deviceGroupNameHeizung));
    setDrinkWaterListList(getDeviceListByGroup(_constants.deviceGroupNameTrinkwasser));
  }, [filteredDeviceList]);
  const headers = (0, _react.useMemo)(() => ({
    drinkWater: [{
      text: tI[34] || '' /* Drinking water */,
      align: 'left',
      style: {
        fontSize: '18px'
      }
    }, {
      text: ''
    }],
    heater: [{
      text: tI[10] || '' /* Heater */,
      align: 'left',
      style: {
        fontSize: '18px'
      }
    }, {
      text: ''
    }]
  }), [tI]);

  /** @todo refactor useMemo in return */
  return (0, _react.useMemo)(() => {
    const tables = [{
      header: headers.drinkWater,
      body: drinkWaterList,
      id: 1
    }, {
      header: headers.heater,
      body: heaterList,
      id: 2
    }];
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      spacing: 5
    }, tables.map(table => /*#__PURE__*/_react.default.createElement(_material.Grid, {
      key: table.id,
      item: true,
      xl: 6,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_DenseTable.default, {
      header: table.header
    }, table.body.map(function () {
      let device = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/_react.default.createElement(_DeviceRows.DeviceRows, {
        key: device.thingPDIDDevice,
        device: device
      });
    })))));
  }, [drinkWaterList, heaterList, headers]);
});